import { GraphQLNonNull, GraphQLObjectType, GraphQLString } from 'graphql'

export interface BaseAssessRule {
  readonly name: string
  readonly title: string
}

export const baseAssessRule = new GraphQLObjectType({
  name: 'BaseAssessRule',
  fields: () => ({
    name: {
      description: 'Rule name (considered as ID)',
      type: new GraphQLNonNull(GraphQLString)
    },
    title: {
      description: 'Rule title',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})
